import { render, staticRenderFns } from "./ConfirmDeleteCustomer.vue?vue&type=template&id=0f16fa67&scoped=true&"
import script from "./ConfirmDeleteCustomer.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteCustomer.vue?vue&type=style&index=0&id=0f16fa67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16fa67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
})
